import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import workspaceReducer from './slices/workspaceSlice';
import uiReducer from './slices/uiSlice';
import notificationReducer from './slices/notificationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    workspace: workspaceReducer,
    ui: uiReducer,
    notification: notificationReducer,
  },
});

export default store;

export * from './slices/authSlice';
export * from './slices/workspaceSlice';
export * from './slices/uiSlice';
export * from './slices/notificationSlice';
